<template>
  <div
    class="flex h-[1550px] grid-cols-2 flex-col gap-8 md:grid lg:grid-cols-12"
  >
    <ProductCardSkeleton
      class="gallery row-start-1 lg:col-start-1 lg:col-end-9"
    />
    <SkeletonLoader
      type="custom"
      class="actions row-start-1 row-end-4 h-full lg:col-start-9 lg:col-end-13"
    />
    <SkeletonLoader
      type="custom"
      class="row-start-2 row-end-4 flex h-full flex-col lg:col-start-1 lg:col-end-5"
    />
    <SkeletonLoader
      type="custom"
      class="row-start-2 row-end-4 flex h-full flex-col lg:col-start-5 lg:col-end-9"
    />
  </div>
</template>
